import { AdacInput } from '@adac-de/component-library';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styles from './delivery-address-section.module.scss';
import {
  CHAR_LIMITATION_ERROR,
  CHAR_NUM_LIMITATION_ERROR,
  ERROR_MESSAGE,
  REGEX_HOUSENR,
  REGEX_LATIN_ALPHABET,
  REGEX_STREET,
  REGEX_ZIPCODE
} from './form-variables';

export type DeliveryAddressFormFields = {
  street: string;
  houseNr: string;
  city: string;
  zipcode: string;
};

export const DeliveryAddressSection: React.FC = () => {
  const {
    formState: { errors },
    register,
    watch
  } = useFormContext<DeliveryAddressFormFields>();

  //bugfix: to make autofill work we need to watch the inputs
  return (
    <fieldset className={styles.deliveryAddressGrid} aria-labelledby="adress-headline">
      <div className={styles.addressCol}>
        <AdacInput
          className={styles.formStreet}
          id="street"
          label="Straße"
          type="text"
          error={errors.street && CHAR_NUM_LIMITATION_ERROR}
          value={watch('street')}
          {...register('street', {
            minLength: 2,
            maxLength: 40,
            pattern: REGEX_STREET,
            required: true
          })}
        />
        <AdacInput
          className={styles.formHouseNr}
          id="housenr"
          label="Hausnummer"
          type="text"
          error={errors.houseNr && ERROR_MESSAGE}
          value={watch('houseNr')}
          {...register('houseNr', {
            minLength: 1,
            maxLength: 4,
            pattern: REGEX_HOUSENR,
            required: true
          })}
        />
      </div>
      <div className={styles.addressCol}>
        <AdacInput
          className={styles.formZipcode}
          id="zipcode"
          label="PLZ"
          type="text"
          value={watch('zipcode')}
          error={errors.zipcode && ERROR_MESSAGE}
          {...register('zipcode', {
            minLength: 5,
            maxLength: 5,
            pattern: REGEX_ZIPCODE,
            required: true
          })}
        />
        <AdacInput
          className={styles.formCity}
          id="city"
          label="Ort"
          type="text"
          error={errors.city && CHAR_LIMITATION_ERROR}
          value={watch('city')}
          {...register('city', {
            minLength: 2,
            maxLength: 40,
            pattern: REGEX_LATIN_ALPHABET,
            required: true
          })}
        />
      </div>
    </fieldset>
  );
};
